import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-3 gap-3 md:grid-cols-5 lg:grid-cols-9 lg:gap-4">
      {categories.map((item) => (
        <Link
          key={item.id}
          to={`/category?type=${item.id}`}
          className="group flex flex-col items-center gap-2.5 rounded-lg border border-background-200 bg-background-50 px-2 py-5 text-center transition-colors hover:border-accent-400 hover:bg-accent-50"
        >
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-colors group-hover:bg-accent-500 group-hover:text-foreground-950">
            <i className={`${item.icon} text-xl`}></i>
          </span>
          <span className="text-sm font-semibold text-foreground-900">{item.name}</span>
          <span className="text-[11px] text-foreground-400">{item.count} 部</span>
        </Link>
      ))}
    </div>
  );
}